import { useState, useEffect } from 'react';
import { Map, useMap } from '@vis.gl/react-google-maps';

import { StoreLocatorMarker } from './StoreLocatorMarker';
import { StoreLocation } from './StoreLocation';
import styling_presets from '../utils/maps_styling_presets.json';

const sectionSettings = JSON.parse(document.querySelector('[data-store-location-section-settings]').innerHTML);
const storeLocation= JSON.parse(document.querySelector('[data-store-location-section-settings]').innerHTML).location;

export const StoreLocationSection = () => {
  const [apiLoaded, setApiLoaded] = useState(false); // checks if google maps api is loaded

  const map = useMap('store-locator-map'); // gives access to the instanced map object

  useEffect(() => {
    const checkApiLoaded = setInterval(() => {
      if (window.google && window.google.maps.Map) {
        setApiLoaded(true);
        clearInterval(checkApiLoaded);
      }
    }, 100);

    return () => clearInterval(checkApiLoaded);
  }, []);

  return (
    <div className="store-locator__content">
      <div className='store-locator__controls'>
        <div className='store-locator__stores-list' open>
          {storeLocation && (
            <StoreLocation key={storeLocation.id} store={storeLocation} map={map} />
          )}
        </div>
      </div>

      {apiLoaded ? (
        <Map
          className={`store-locator__map open`}
          defaultCenter={{lat: parseFloat(storeLocation.latitude), lng: parseFloat(storeLocation.longitude)}}
          defaultZoom={15}
          gestureHandling={'greedy'}
          disableDefaultUI={true}

          id='store-locator-map'
        >
          {storeLocation && (
            <StoreLocatorMarker key={storeLocation.id} store={storeLocation} activeStore={storeLocation} />
          )}
        </Map>
      ) : (
        <div className='store-locator__map loading'>
        </div>
      )}
    </div>
  )
}
